// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"5ad5133a2608f5cf","6496":"cfaca55f6ff3f389"}[chunkId] + ".js";
};